import { render, staticRenderFns } from "./FormRecuperarSenha.vue?vue&type=template&id=dc22dae2&scoped=true"
import script from "./FormRecuperarSenha.vue?vue&type=script&lang=js"
export * from "./FormRecuperarSenha.vue?vue&type=script&lang=js"
import style0 from "./FormRecuperarSenha.vue?vue&type=style&index=0&id=dc22dae2&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc22dae2",
  null
  
)

export default component.exports